var watchlist = {
	createWatchlistAction: "Crea Watchlist",
	editWatchlistAction: "Modifica Watchlist",
	deleteWatchlistAction: "Elimina Watchlist",
	addPosition: "Aggiungi Posizione",
	deletePosition: "Elimina Posizione",
	noWatchlistTitle: "Info",
	noWatchlistMessage: "Nessuna watchlist è stata ancora creata. Fare clic sul pulsante \"Crea Watchlist\" e compilare il modulo per creare una watchlist.",
	showActions: "Mostra azioni"
};
var it = {
	watchlist: watchlist
};

export { it as default, watchlist };
